/* BEDZ KING SEARCH 2.1 - ORDER-INDEPENDENT CATALOG PARSER */

(function () {
  'use strict';

  function normalizeSearchTerm(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/&/g, ' and ')
      .replace(/[\/_-]+/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function cleanSpaces(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  var phraseRules = [
    {
      tag: 'Low Loft with Under Bed',
      phrases: [
        'low loft with under beds', 'low loft with under bed',
        'low loft with underbeds', 'low loft with underbed',
        'low loft under beds', 'low loft under bed',
        'low loft underbeds', 'low loft underbed',
        'loft with under beds', 'loft with under bed',
        'loft with underbeds', 'loft with underbed',
        'loft under beds', 'loft under bed',
        'loft underbeds', 'loft underbed',
        'under bed loft', 'underbed loft'
      ]
    },
    {
      tag: 'Low Loft with Tent',
      phrases: ['low loft with tent', 'low loft tent', 'loft with tent', 'loft tent', 'tent loft']
    },
    { tag: 'Breezy-Blue', phrases: ['breezy blue'] },
    { tag: 'Dark-Cherry', phrases: ['dark cherry'] },
    { tag: 'Castle-Princess', phrases: ['castle princess', 'princess castle'] },
    {
      tag: 'Drawers',
      phrases: [
        'storage drawers', 'storage drawer', 'under bed drawers',
        'under bed drawer', 'underbed drawers', 'underbed drawer'
      ]
    }
  ];

  var tokenRules = [
    { tag: 'Tall', words: ['tall', 'taller', 'high'] },
    { tag: 'Stairway', words: ['stairway', 'stairways', 'stairs', 'stair', 'staircase', 'staircases'] },
    { tag: 'Ladder', words: ['ladder', 'ladders'] },
    { tag: 'Drawers', words: ['drawer', 'drawers'] },
    { tag: 'Trundle', words: ['trundle', 'trundles'] },
    { tag: 'White', words: ['white'] },
    { tag: 'Gray', words: ['gray', 'grey'] },
    { tag: 'Dark-Cherry', words: ['cherry'] },
    { tag: 'Breezy-Blue', words: ['breezy'] },
    { tag: 'Blue', words: ['blue'] },
    { tag: 'Black', words: ['black'] },
    { tag: 'Rustic', words: ['rustic'] },
    { tag: 'Castle-Princess', words: ['castle', 'princess'] }
  ];

  var genericWords = [
    'a', 'an', 'and', 'bed', 'beds', 'bunk', 'bunks', 'bunkbed', 'bunkbeds',
    'color', 'colour', 'for', 'in', 'of', 'style', 'the', 'with', 'size', 'sizes',
    'kid', 'kids', 'child', 'children', 'childrens', 'wood', 'wooden', 'solid',
    'pine', 'furniture', 'room', 'bedroom'
  ];

  function addUnique(list, value) {
    if (list.indexOf(value) === -1) list.push(value);
  }

  function containsWord(value, word) {
    return new RegExp('(^|\\s)' + escapeRegExp(word) + '(?=\\s|$)').test(value);
  }

  function countWord(value, word) {
    var pattern = new RegExp('(^|\\s)' + escapeRegExp(word) + '(?=\\s|$)', 'g');
    var count = 0;
    String(value || '').replace(pattern, function () { count += 1; return ''; });
    return count;
  }

  function consumeWord(value, word) {
    return cleanSpaces(value.replace(
      new RegExp('(^|\\s)' + escapeRegExp(word) + '(?=\\s|$)', 'g'),
      ' '
    ));
  }

  function consumePhrase(value, phrase) {
    var matched = false;
    var updatedValue = value.replace(
      new RegExp('(^|\\s)' + escapeRegExp(phrase) + '(?=\\s|$)', 'g'),
      function () { matched = true; return ' '; }
    );
    return { matched: matched, value: cleanSpaces(updatedValue) };
  }

  function consumeAllOccurrences(value, word) {
    var workingValue = value;
    while (containsWord(workingValue, word)) workingValue = consumeWord(workingValue, word);
    return workingValue;
  }

  function removeGenericWords(value) {
    var workingValue = value;
    genericWords.forEach(function (word) {
      workingValue = consumeAllOccurrences(workingValue, word);
    });
    return cleanSpaces(workingValue);
  }

  function buildStructuredQuery(tags, productTypes, extraClauses) {
    var parts = tags.map(function (tag) {
      return tag.indexOf(' ') !== -1 ? 'tag:"' + tag + '"' : 'tag:' + tag;
    });

    productTypes.forEach(function (productType) {
      parts.push('product_type:"' + productType + '"');
    });

    (extraClauses || []).forEach(function (clause) {
      parts.push(clause);
    });

    return parts.join(' ');
  }

  function buildTitleClauses(value) {
    return cleanSpaces(value).split(' ').filter(Boolean).map(function (word) {
      return 'title:' + word;
    });
  }

  function looksLikeSku(value) {
    return /(^|\s)[a-z]{1,6}\d{2,}[a-z0-9-]*(?=\s|$)/i.test(String(value || ''));
  }

  function detectProductTypeIntent(value, productTypes) {
    var workingValue = value;
    var hasBunk = containsWord(workingValue, 'bunk') || containsWord(workingValue, 'bunks') ||
      containsWord(workingValue, 'bunkbed') || containsWord(workingValue, 'bunkbeds');
    var hasCaptain = containsWord(workingValue, 'captain') || containsWord(workingValue, 'captains');
    var hasMattress = containsWord(workingValue, 'mattress') || containsWord(workingValue, 'mattresses');
    var hasProtector = containsWord(workingValue, 'protector') || containsWord(workingValue, 'protectors');

    if (hasBunk) {
      addUnique(productTypes, 'Bunk Beds');
    } else if (hasCaptain) {
      addUnique(productTypes, 'Captains Bed');
      workingValue = consumeAllOccurrences(workingValue, 'captain');
      workingValue = consumeAllOccurrences(workingValue, 'captains');
    } else if (hasMattress && hasProtector) {
      addUnique(productTypes, 'Mattress Protector');
      workingValue = consumeAllOccurrences(workingValue, 'mattress');
      workingValue = consumeAllOccurrences(workingValue, 'mattresses');
      workingValue = consumeAllOccurrences(workingValue, 'protector');
      workingValue = consumeAllOccurrences(workingValue, 'protectors');
    } else if (hasMattress) {
      addUnique(productTypes, 'Mattress');
      workingValue = consumeAllOccurrences(workingValue, 'mattress');
      workingValue = consumeAllOccurrences(workingValue, 'mattresses');
    }

    return workingValue;
  }

  function consumeLowBunkIntent(value, tags) {
    var workingValue = value;
    var hasLowWord = containsWord(workingValue, 'low');
    var hasShortWord = containsWord(workingValue, 'short') || containsWord(workingValue, 'shorter');
    var hasBunkWord = containsWord(workingValue, 'bunk') || containsWord(workingValue, 'bunks') ||
      containsWord(workingValue, 'bunkbed') || containsWord(workingValue, 'bunkbeds');

    if (!hasBunkWord || (!hasLowWord && !hasShortWord)) return workingValue;

    addUnique(tags, 'BedzLowBunk');
    ['low', 'short', 'shorter', 'profile'].forEach(function (word) {
      workingValue = consumeAllOccurrences(workingValue, word);
    });
    ['bunk', 'bunks', 'bunkbed', 'bunkbeds'].forEach(function (word) {
      workingValue = consumeAllOccurrences(workingValue, word);
    });
    return workingValue;
  }

  function consumeLowLoftIntent(value, tags) {
    var workingValue = value;
    var hasLoft = containsWord(workingValue, 'loft') || containsWord(workingValue, 'lofts');
    if (!hasLoft) return workingValue;

    if (tags.indexOf('Low Loft with Under Bed') === -1 && tags.indexOf('Low Loft with Tent') === -1) {
      addUnique(tags, 'Low Loft');
    }

    ['low', 'loft', 'lofts'].forEach(function (word) {
      workingValue = consumeAllOccurrences(workingValue, word);
    });
    return workingValue;
  }

  function consumeSizeIntent(value, tags) {
    var workingValue = value;
    var twinCount = countWord(workingValue, 'twin');
    var fullCount = countWord(workingValue, 'full');

    if (twinCount >= 2 && fullCount === 0) {
      addUnique(tags, 'BedzSizeTwinTwin');
      workingValue = consumeAllOccurrences(workingValue, 'twin');
      workingValue = consumeAllOccurrences(workingValue, 'over');
      return workingValue;
    }

    if (twinCount >= 1 && fullCount >= 1) {
      addUnique(tags, 'BedzSizeTwinFull');
      workingValue = consumeAllOccurrences(workingValue, 'twin');
      workingValue = consumeAllOccurrences(workingValue, 'full');
      workingValue = consumeAllOccurrences(workingValue, 'over');
      return workingValue;
    }

    if (fullCount >= 2 && twinCount === 0) {
      addUnique(tags, 'BedzSizeFullFull');
      workingValue = consumeAllOccurrences(workingValue, 'full');
      workingValue = consumeAllOccurrences(workingValue, 'over');
      return workingValue;
    }

    return workingValue;
  }

  function consumeSingleSizeWithStyleIntent(value, tags, extraClauses) {
    var workingValue = value;
    var twinCount = countWord(workingValue, 'twin');
    var fullCount = countWord(workingValue, 'full');
    var hasStyleIntent = tags.indexOf('Ladder') !== -1 || tags.indexOf('Stairway') !== -1;

    if (!hasStyleIntent) return workingValue;

    if (twinCount === 1 && fullCount === 0) {
      addUnique(extraClauses, '(tag:BedzSizeTwinTwin OR tag:BedzSizeTwinFull)');
      workingValue = consumeAllOccurrences(workingValue, 'twin');
      workingValue = consumeAllOccurrences(workingValue, 'over');
      return workingValue;
    }

    if (fullCount === 1 && twinCount === 0) {
      addUnique(extraClauses, '(tag:BedzSizeTwinFull OR tag:BedzSizeFullFull)');
      workingValue = consumeAllOccurrences(workingValue, 'full');
      workingValue = consumeAllOccurrences(workingValue, 'over');
      return workingValue;
    }

    return workingValue;
  }

  function consumePhraseRules(value, tags) {
    var workingValue = value;
    phraseRules.forEach(function (rule) {
      var matched = false;
      rule.phrases.forEach(function (phrase) {
        var result;
        if (matched) return;
        result = consumePhrase(workingValue, phrase);
        if (result.matched) {
          workingValue = result.value;
          addUnique(tags, rule.tag);
          matched = true;
        }
      });
    });
    return workingValue;
  }

  function consumeTokenRules(value, tags) {
    var workingValue = value;
    tokenRules.forEach(function (rule) {
      var matchedWord = '';
      rule.words.some(function (word) {
        if (containsWord(workingValue, word)) {
          matchedWord = word;
          return true;
        }
        return false;
      });
      if (!matchedWord) return;
      addUnique(tags, rule.tag);
      rule.words.forEach(function (word) {
        workingValue = consumeAllOccurrences(workingValue, word);
      });
    });
    return workingValue;
  }

  function removeOverWord(value) {
    return consumeAllOccurrences(value, 'over');
  }

  function mapSearchQuery(rawValue) {
    var originalValue = String(rawValue || '').trim();
    var workingValue;
    var tags = [];
    var productTypes = [];
    var extraClauses = [];

    if (!originalValue) return originalValue;
    if (/^(tag:|product_type:|title:)/i.test(originalValue)) return originalValue;
    if (looksLikeSku(originalValue)) return originalValue;

    workingValue = normalizeSearchTerm(originalValue);
    workingValue = consumePhraseRules(workingValue, tags);
    workingValue = detectProductTypeIntent(workingValue, productTypes);
    workingValue = consumeLowBunkIntent(workingValue, tags);
    workingValue = consumeLowLoftIntent(workingValue, tags);
    workingValue = consumeSizeIntent(workingValue, tags);
    workingValue = consumeTokenRules(workingValue, tags);
    workingValue = consumeSingleSizeWithStyleIntent(workingValue, tags, extraClauses);

    if (
      tags.indexOf('BedzSizeTwinTwin') !== -1 ||
      tags.indexOf('BedzSizeTwinFull') !== -1 ||
      tags.indexOf('BedzSizeFullFull') !== -1 ||
      extraClauses.length > 0
    ) {
      workingValue = removeOverWord(workingValue);
    }

    workingValue = removeGenericWords(workingValue);

    if (workingValue !== '') {
      buildTitleClauses(workingValue).forEach(function (clause) {
        addUnique(extraClauses, clause);
      });
    }

    if (tags.length === 0 && productTypes.length === 0 && extraClauses.length === 0) {
      return originalValue;
    }

    return buildStructuredQuery(tags, productTypes, extraClauses);
  }

  var helpSearchPhrases = [
    'assembly', 'assembly instruction', 'assembly instructions', 'bunk bed assembly',
    'bunk bed assembly instruction', 'bunk bed assembly instructions', 'loft bed assembly',
    'loft bed assembly instructions', 'instruction', 'instructions', 'assembly manual',
    'dimensions', 'dimension', 'bed dimensions', 'bunk bed dimensions', 'loft bed dimensions',
    'measurements', 'measurement', 'bed measurements', 'bunk bed measurements', 'warranty',
    'warranties', 'manufacturer warranty', 'bed warranty', 'bunk bed warranty', 'shipping',
    'shipping information', 'delivery', 'delivery information', 'shipping and delivery',
    'fedex delivery', 'return', 'returns', 'return policy', 'exchange', 'exchanges',
    'exchange policy', 'returns and exchanges', 'safety', 'bunk bed safety', 'safety information',
    'certification', 'safety certification', 'bunk bed certification', 'bunk bed standards',
    'ordering', 'ordering information', 'payment', 'payments', 'payment information', 'faq',
    'faqs', 'frequently asked questions', 'customer service', 'contact', 'contact us',
    'track order', 'track my order', 'care', 'maintenance', 'care and maintenance',
    'cleaning', 'bunk bed cleaning'
  ];

  function isHelpSearch(rawValue) {
    return helpSearchPhrases.indexOf(normalizeSearchTerm(rawValue)) !== -1;
  }

  function getSearchTypeInput(form) {
    return form.querySelector('input[name="type"]');
  }

  function setSearchType(form, value) {
    var typeInput = getSearchTypeInput(form);
    if (!typeInput) {
      typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      form.appendChild(typeInput);
    }
    typeInput.value = value;
  }

  function getStructuredQueryInput(form) {
    return form.querySelector('input[data-bedz-structured-query="true"]');
  }

  function removeLegacyDisplayInput(form) {
    var legacyDisplayInput = form.querySelector('input[type="hidden"][name="bedz_query"]');
    if (legacyDisplayInput && legacyDisplayInput.parentNode) {
      legacyDisplayInput.parentNode.removeChild(legacyDisplayInput);
    }
  }

  function resetStructuredSearch(form, searchInput) {
    var structuredInput = getStructuredQueryInput(form);
    if (structuredInput && structuredInput.parentNode) structuredInput.parentNode.removeChild(structuredInput);
    removeLegacyDisplayInput(form);
    searchInput.name = 'q';
  }

  function prepareStructuredSearch(form, searchInput, originalValue, mappedValue) {
    var structuredInput = getStructuredQueryInput(form);
    removeLegacyDisplayInput(form);
    if (!structuredInput) {
      structuredInput = document.createElement('input');
      structuredInput.type = 'hidden';
      structuredInput.setAttribute('data-bedz-structured-query', 'true');
      form.appendChild(structuredInput);
    }
    structuredInput.name = 'q';
    structuredInput.value = mappedValue;
    searchInput.name = 'bedz_query';
    searchInput.value = originalValue;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var action;
    var searchInput;
    var originalValue;
    var mappedValue;

    if (!form || form.tagName !== 'FORM' || form.getAttribute('role') !== 'search') return;
    action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;

    searchInput = form.querySelector('input[type="search"]');
    if (!searchInput) return;

    originalValue = String(searchInput.value || '').trim();
    if (isHelpSearch(originalValue)) {
      resetStructuredSearch(form, searchInput);
      setSearchType(form, 'page');
      return;
    }

    setSearchType(form, 'product');
    mappedValue = mapSearchQuery(originalValue);

    if (mappedValue !== originalValue) {
      prepareStructuredSearch(form, searchInput, originalValue, mappedValue);
      return;
    }

    resetStructuredSearch(form, searchInput);
  });

  function getDisplayQueryFromUrl() {
    if (typeof window.URLSearchParams !== 'function') return '';
    var params = new window.URLSearchParams(window.location.search);
    return String(params.get('bedz_query') || '').trim();
  }

  function restoreDisplayQuery() {
    var displayQuery = getDisplayQueryFromUrl();
    var searchAgainInput;
    var searchTitle;
    var productCount;

    if (!displayQuery) return;

    searchAgainInput = document.querySelector('body.template-search .bedz-search-form__input');
    if (searchAgainInput) searchAgainInput.value = displayQuery;

    searchTitle = document.querySelector('body.template-search .bedz-search-title');
    if (!searchTitle) return;

    productCount = document.querySelector('body.template-search .bedz-search-product-count');
    searchTitle.textContent = productCount
      ? 'Search Results for “' + displayQuery + '”'
      : 'No results for “' + displayQuery + '”';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreDisplayQuery);
  } else {
    restoreDisplayQuery();
  }

  window.BedzSearchQuery = { map: mapSearchQuery };
}());
